import { Slot } from '@radix-ui/react-slot';
import { cn, withRef } from '@udecode/cn';
import { cva,type VariantProps } from 'class-variance-authority';

export const buttonVariants = cva(
    'inline-flex cursor-pointer items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap ring-offset-background transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
    {
        defaultVariants: {
            size: 'sm',
            variant: 'default',
        },
        variants: {
            isMenu: {
                true: 'w-full cursor-pointer justify-start',
            },
            size: {
                icon: 'size-[28px] rounded-md px-1.5',
                lg: 'h-9 rounded-md px-4',
                md: 'h-8 px-3 text-sm',
                none: '',
                sm: 'h-[28px] rounded-md px-2.5',
                xs: 'h-8 rounded-md px-3 text-xs',
            },
            variant: {
                default: 'bg-primary-500 text-primary-foreground hover:bg-primary/90',
                destructive:
          'bg-destructive text-destructive-foreground hover:bg-destructive/90',
                ghost: 'hover:bg-accent hover:text-accent-foreground',
                inlineLink: 'text-base text-primary underline underline-offset-4',
                link: 'text-primary underline-offset-4 hover:underline',
                outline:
          'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
                secondary:
          'bg-secondary text-secondary-foreground hover:bg-secondary/80',
            },
        },
    }
);

export const Button = withRef<
  'button',
  {
    asChild?: boolean;
  } & VariantProps<typeof buttonVariants>
>(({ asChild = false, className, isMenu, size, variant, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';

    return (
        <Comp
            ref={ref}
            className={cn(buttonVariants({ className, isMenu, size, variant }))}
            {...props}
        />
    );
});
